import logo from './assets/palnet1.png';
import './App.css';
import Animation from './DesktopArabicKyboard/animation';
import ArabicKeyboard from './DesktopArabicKyboard/ArabicKeyboard';

import PhonKeyboard from './PhonKeyboard/PhonKeyboard';



import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Rename BrowserRouter as Router


function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <Router>
          <div className="row">
            {isMobile ? (
              <PhoneComponent />
            ) : (
              <Routes>
                <Route path="/" element={<Appp />} />
              </Routes>
            )}
          </div>
        </Router>
      </header>
    </div>
  );
}



function Appp() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <div className="row-container" style={{ display: 'flex', alignItems: 'center' }}>

        <div className="animation" style={{ position: 'absolute', top: 1, left: 0, transform: 'translateX(300%)' }}>
          <Animation />
        </div>
        <div className="animation" style={{ position: 'absolute', top: 0.5, left: '50%', transform: 'translateX(-50%)' }}>
          <ArabicKeyboard />
        </div>
      </div>
      <section>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </section>
    </div>
  );
}



function PhoneComponent() {
  return (
    <div  className="Phone">
      <PhonKeyboard/>
    </div>
  );
}

export default App;
